// LoaderBar (extends createjs.Container) ----------------------
(function(cs) {
	var Shape = include('createjs.Shape');

function LoaderBar() {
	this.Container_constructor();
	this.ldr_border = new Shape();
	this.ldr_fill = new Shape();
	this.setup();
}
var p = cs.extend(LoaderBar, cs.Container);

// used to add the graphics to the shape
p.setup = function() {
	this.ldr_border.graphics.s(app.config.COLORS.WHITE).ss(2).rr(0, 0, app.config.GAME.LOADER.wid, app.config.GAME.LOADER.hgt, app.config.GAME.LOADER.rnd).ef();
	this.ldr_fill.graphics.f(app.config.COLORS.WHITE).dr(app.config.GAME.LOADER.ofs, app.config.GAME.LOADER.ofs, 90.0, app.config.GAME.LOADER.ofs_hgt).ef();
	this.x = app.config.GAME.LOADER.x;
	this.y = app.config.GAME.LOADER.y;
	this.addChild(this.ldr_border);
	this.addChild(this.ldr_fill);
};

// used to set the progress of the bar
p.setbar = function(val) {
	val = Math.max(0.25, val);
	this.ldr_fill.graphics.clear();
	this.ldr_fill.graphics.f(app.config.COLORS.WHITE).dr(app.config.GAME.LOADER.ofs, app.config.GAME.LOADER.ofs, (app.config.GAME.LOADER.max * val), app.config.GAME.LOADER.ofs_hgt).ef();
};

namespace('WGBH').LoaderBar = cs.promote(LoaderBar, 'Container');

}(createjs));